import React, {Component, Fragment} from 'react'
import SearchFilter from "../../../Templates/SearchFilter"
import { SORT, toggleSorting } from "../../../Templates/functions"
import { UserListSkeleton, WIListSkeleton } from '../../../Templates/icons'
import FormRow from '../../../Templates/FormRow'
import CircularProgress from '@material-ui/core/CircularProgress';
import RoleFilterModal from './RoleFilterModal'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPenToSquare } from '@fortawesome/free-regular-svg-icons'
class UserList extends Component {
    state = {
        filteredUsers: [],
        filteringByRole: false,
        sortingByUsername: 2,
        sortingByRole: 2,
        checkBoxes: {"Artisan": true, "Work Lead": true, "Shop Supervisor": true, "Engineer": true, "E&E": true, "QA": true}
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevProps.loading !== this.props.loading) {
            this.getFirstUser();
        }
    }

    getFirstUser = () =>{
        let firstUserSelected = false;
        let rowData = this.props.users.map(user => {
            if(!firstUserSelected){
                firstUserSelected = true;
                this.selectUser(user._id)               
            }
        })
    }

    filterUsersList = (searchText, index) => {
        if (searchText === "") {
            this.setState(prevState => ({
                filteredUsers: [],
                filteringUsers: false,
                searchText: "",
            }))
        }

        if (searchText) {
            let users = this.filterUsers(searchText)
            this.setState(prevState => ({
                filteredUsers: users,
                filteringUsers: true,
                searchText
            }))
        }
    }

    handleCheckBox = (e, role) => {
        e.stopPropagation()
        let checkBoxes = this.state.checkBoxes
        if (checkBoxes[role]) {
            checkBoxes[role] = false
        } else {
            checkBoxes[role] = true
        }
        let checkValues = Object.values(checkBoxes)
        let isFiltering = checkValues.some(value => value === true)
        if (isFiltering) {
            return this.setState({
                checkBoxes
            })
        }
    }

    filterUsers = (searchText) => {
        let usersList = this.props.users;
        let usersWithMatch = usersList.filter(user => {
            return user.username.toLowerCase().includes(searchText);
        });
        return usersWithMatch;
    }
    
    

    selectUser = (id) => {
        this.props.selectUser(id)
    }

    renderUsersList = () => {
        if (this.props.loading) {
            let rowData = [UserListSkeleton, UserListSkeleton, UserListSkeleton, UserListSkeleton, UserListSkeleton, UserListSkeleton, UserListSkeleton]
            return <Fragment>
                <FormRow
                    isHeader={true}
                    rowData={["Name", "Role"]}
                    filterCBs={[null,true]}
                    callbacks={[() => null]}
                    states={[]}
                    widths={["50%", "50%"]}
                />
                <div id="rows-container">
                    {rowData.map((row, index) => {
                        return <FormRow
                            rowData={row}
                            widths={["65%", "20%", "10%"]}
                            selectRow={() => null}
                            isSelected={null}
                            centeredIndices={[1, 2]}
                            key={index}
                        />
                    })}
                </div>
            </Fragment>
        } else {     
        // this.focusScroll(this.props.selectedWorkInstructionId)   
        let usersList
        let filteredUsers = this.state.filteredUsers

        if (this.state.filteringUsers) {
            usersList = filteredUsers
        } else {
            usersList = this.props.users || []
        }

        if (this.state.sortingByUsername) {
            usersList = SORT(this.state.sortingByUsername, usersList, "username")
        }

        // usersList = usersList.filter(user => this.state.checkBoxes[user.role])
        let userIds = []
        let isSelected = {}
        let rowData = usersList.map(user => {
            isSelected[user.username] = user === this.props.selectedUser
            let data = []
            data.push(user.username)
            data.push(user.role)
            userIds.push(user._id)
            return data
        })

        return <Fragment>
                <FormRow
                    isHeader={true}
                    rowData={["Name", "Role"]}
                    callbacks={[() => toggleSorting(this.state.sortingByUsername,
                        (value) => this.setState({
                            sortingByUsername: value,
                            sortingByRole: 0,
                        })
                    ), null]}
                    filterCBs={[null, 
                        <RoleFilterModal 
                        setFilter={this.setFilter}
                        handleCheckBox={this.handleCheckBox}
                        checkBoxes={this.state.checkBoxes}
                        />]}
                    states={[this.state.sortingByUsername, this.state.sortingByRole]}
                    widths={["50%", "50%"]}
                />
            <div id="rows-container">
                {rowData.map((row, index) => {
                   return <FormRow 
                        key={index}
                        rowData={row}
                        widths={["50%", "50%"]}
                        selectRow={() => this.selectUser(userIds[index])}
                        isSelected={isSelected[row[0]]}
                />})}
            </div>
        </Fragment>
        }
    }

    render() {
        const {isLoadingUser} = this.props
        return <div id="user-management-content-container" className="flex-column shadow">
            <div id="user-management-page-header">
                <h3 className="FontSize20">USER</h3> 
            </div>
            <div className="flex-apart" style={{ alignItems: "center" }}>
                <SearchFilter filterList={this.filterUsersList} />
            </div>
            {isLoadingUser ? (
                <div id="user-management-page-user-list" className="overflow" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                    <CircularProgress />
                </div>
            ) : (
                <ul id="user-management-page-user-list" className="overflow">
                    {this.renderUsersList()}
                </ul>
            )}
            {(this.props.currentUserRole === 'Dev' || this.props.currentUserRole === 'Shop Supervisor') &&
                <div id="new-work-instruction-container" className="clickable" onClick={this.props.openModal}>
                    <div style={{marginRight:"auto", marginLeft:"auto",color:"white", display:"flex",bottom:"5px"}}>
                        <p style={{ marginRight: ".625em", fontSize:"18px" }}>Create New User</p>
                        <FontAwesomeIcon icon={faPenToSquare}/>
                    </div>    
                </div>
            }
        </div>
           
    }
}

export default UserList